import { useState } from "react";

/** Copy-to-clipboard with a transient "copied" flag (the app has no toast system; feedback
 *  stays inline). Shared so every copy control behaves the same and reports the same way. */
export function useCopyToClipboard(onCopied?: () => void): {
  copied: boolean;
  copy: (value: string) => Promise<void>;
} {
  const [copied, setCopied] = useState(false);

  const copy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      onCopied?.();
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard unavailable (permissions/insecure context) — the value stays
      // selectable as text wherever it's rendered.
    }
  };

  return { copied, copy };
}
